import { SlashCommand } from './types';

export const justLyricsCommands: SlashCommand[] = [
    { id: 'lyrics', name: 'Find Lyrics', trigger: '/lyrics', description: 'Fetch song lyrics', category: 'Entertainment', icon: 'fa-music', mode: 'tool', tool: 'just-lyrics', prefix: 'lyrics for: ', integration: 'JustLyrics' }
];
